/* batida-v7-forms.js (29.09, Aleksandra: the forms promise "prosto do właściwej osoby"): the website forms go to the
   right people. Forms marked data-v7-route="<form id>" (kontakt, horeca, kariera, catering, piatek) are posted first to
   Batida Connect (POST /apps/connect/forms/submit; repo batida-rates, src/forms.ts), which e-mails the people set in
   its admin (Ustawienia -> Powiadomienia -> "Formularze na stronie"; from sklep@batida.pl, "Odpowiedz" = the customer).
   - Success: the page opens the same address with ?contact_posted=true#<form id>, exactly where Shopify's own form lands
     after sending, so every form shows the same thank-you as before (Piątek: its sessionStorage flag, set by its script).
   - ANY failure (404 before the deploy, switched off, refused, 5xx, network, no answer in 10 s): the form is sent the old
     way, through Shopify's contact form (with Shopify's spam check) to sklep@ - nothing is lost, the visitor sees nothing.
   How: one submit listener on document in the CAPTURE phase. It runs after the browser's own checks (required fields,
   the required consent) and before Shopify's spam check (a document listener in the bubble phase; for forms given to
   Shopify.captcha.protect() the form's own listener), stops the event there, sends, and on failure calls
   form.requestSubmit() again with a pass flag, so that time the event takes its usual path. The hidden sender forms that
   their own scripts fill and requestSubmit() (Piątek w biurze) work the same way.
   Sent: the form's contact[...] fields in their order (what Shopify's e-mail lists), the consent boxes as "Zgoda: …:
   tak/nie", the page, a honeypot field (invisible, bots fill it) and how long the page has been open (< 2 s = a script).
   Loaded by the five form sections; runs once however many sections include it. Browsers without fetch/requestSubmit:
   nothing changes (Shopify's form as before). */
(function () {
  'use strict';
  if (window.__v7Forms) return;
  window.__v7Forms = 1;
  var API = '/apps/connect/forms/submit', WAIT = 10000, T0 = Date.now();
  var CONSENTS = [
    ['customer[accept_regulations_cbx]', 'Zgoda: regulamin i polityka prywatności'],
    ['customer[electronic_contact]', 'Zgoda: kontakt e-mail i telefon'],
    ['customer[accepts_marketing]', 'Zgoda: informacje marketingowe']
  ];

  function honeypot(form) {
    var hp = form.querySelector('input[data-v7-hp]');
    if (hp) return hp;
    var box = document.createElement('div');
    box.setAttribute('aria-hidden', 'true');
    box.style.cssText = 'position:absolute!important;left:-10000px!important;top:auto!important;width:1px!important;height:1px!important;overflow:hidden!important';
    box.innerHTML = '<label>' + (window.batidaT ? window.batidaT('v7.honeypot', 'Nie wypełniaj') : 'Nie wypełniaj') + ' <input type="text" name="v7_website" value="" tabindex="-1" autocomplete="off" data-v7-hp></label>';
    form.appendChild(box);
    return box.querySelector('input');
  }
  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('form[data-v7-route]'), honeypot);
  }

  function collect(form) {
    var fields = {};
    new FormData(form).forEach(function (v, k) {                 // the browser's own rules: DOM order, ticked boxes only
      var m = typeof v === 'string' && /^contact\[(.+)\]$/.exec(k);
      if (!m) return;
      fields[m[1]] = Object.prototype.hasOwnProperty.call(fields, m[1]) && fields[m[1]] ? fields[m[1]] + ', ' + v : v;
    });
    CONSENTS.forEach(function (c) {
      var box = form.querySelector('input[type="checkbox"][name="' + c[0] + '"]');
      if (box) fields[c[1]] = box.checked ? 'tak' : 'nie';
    });
    return fields;
  }

  function post(data) {
    return new Promise(function (resolve) {
      var done = false, ctl = window.AbortController ? new AbortController() : null;
      var timer = setTimeout(function () { finish(false); if (ctl) ctl.abort(); }, WAIT);
      function finish(ok) { if (done) return; done = true; clearTimeout(timer); resolve(ok); }
      try {
        fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data), credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
          .then(function (r) { return r.ok ? r.json().catch(function () { return null; }) : null; })
          .then(function (j) { finish(!!(j && j.ok === true)); }, function () { finish(false); });
      } catch (e) { finish(false); }
    });
  }

  function buttons(form) { return form.querySelectorAll('button[type="submit"], input[type="submit"], button:not([type])'); }
  function busy(form, on) {
    if (on) form.setAttribute('aria-busy', 'true'); else form.removeAttribute('aria-busy');
    Array.prototype.forEach.call(buttons(form), function (b) {
      if (on) { b.__v7Was = b.disabled; b.disabled = true; } else if ('__v7Was' in b) { b.disabled = b.__v7Was; delete b.__v7Was; }
    });
  }

  // the same page Shopify returns to after its own form: ?contact_posted=true#<form id>
  function thanks(form) {
    var u = new URL(location.href);
    u.searchParams.set('contact_posted', 'true');
    u.hash = form.id || '';
    if (u.pathname + u.search === location.pathname + location.search) { history.replaceState(history.state, '', u.href); location.reload(); }
    else location.assign(u.href);
  }

  function oldWay(form, submitter) {
    form.__v7Pass = true;
    setTimeout(function () { form.__v7Pass = false; }, 0);
    try {
      if (submitter && submitter.form === form) form.requestSubmit(submitter); else form.requestSubmit();
    } catch (e) {
      try { form.requestSubmit(); } catch (e2) { HTMLFormElement.prototype.submit.call(form); }
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var id = form.getAttribute('data-v7-route');
    if (!id) return;
    if (form.__v7Pass) { form.__v7Pass = false; return; }       // the fallback: Shopify's own path, untouched
    if (e.defaultPrevented || !window.fetch || !window.Promise || typeof form.requestSubmit !== 'function') return;
    e.preventDefault();
    e.stopPropagation();                                           // Shopify's spam check must not post it as well
    if (form.__v7Busy) return;
    form.__v7Busy = true;
    var submitter = e.submitter || null, hp = honeypot(form);
    var data = { form: id, fields: collect(form), page: location.href.split('#')[0], hp: hp ? hp.value : '', t: Date.now() - T0 };
    busy(form, true);
    post(data).then(function (ok) {
      if (ok) { thanks(form); return; }
      busy(form, false);
      form.__v7Busy = false;
      oldWay(form, submitter);
    });
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
